import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Divider, Row, Avatar, Col, Card, Descriptions, Breadcrumb, Tag } from 'antd';
import { getSurveillant } from './surveillant.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import OptionsSurveillant from './options-surveillant';
import { FaUserEdit } from 'react-icons/fa';
import { UserOutlined } from '@ant-design/icons';
import { getEcole } from '../ecole/ecole.reducer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getSession } from 'app/shared/reducers/authentication';
export const SurveillantDetail = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const { match } = props;
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getSurveillant(props.match.params.id));
  }, []);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const surveillantList = useAppSelector(state => state.surveillant.entity);
  const ecoles = useAppSelector(state => state.ecole.entity);
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));

  return (
    <>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/surveillant/${currentEcole && currentEcole.id}`}>Surveillants</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Row className=" justify-content-center">
          <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 8 }} md={{ span: 5 }} className="pt-4">
            <Avatar size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }} icon={<UserOutlined />} />
            <Descriptions className="p-4">
              <Descriptions.Item label="">
                <Tag color="gray">{surveillantList.authorities?.map(s => s)}</Tag>
              </Descriptions.Item>
            </Descriptions>
          </Col>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }}>
            <h2 style={{ textAlign: 'center' }} className="p-4">
              {' '}
              {surveillantList.firstName} {surveillantList.lastName}{' '}
            </h2>
            <span>
              <Descriptions column={1}>
                <Descriptions.Item label="Matricule">{surveillantList.matricule}</Descriptions.Item>
                <Descriptions.Item label="Login">{surveillantList.login}</Descriptions.Item>
                <Descriptions.Item label="Email">{surveillantList.email}</Descriptions.Item>
                <Descriptions.Item label="Téléphone">{surveillantList.telephone}</Descriptions.Item>
                <Descriptions.Item label="Adresse">{surveillantList.adresse}</Descriptions.Item>
              </Descriptions>
            </span>
          </Col>
          {isNotComptable && (
            <>
              <Divider type="vertical" style={{ height: 'auto' }} />
              <Col lg={{ span: 4 }} xs={{ span: 24 }} md={{ span: 8 }} sm={{ span: 8 }} style={{ textAlign: 'center' }}>
                <OptionsSurveillant {...props} />
              </Col>
            </>
          )}
        </Row>
      </Card>
    </>
  );
};
export default SurveillantDetail;
